import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import clsx from 'clsx';
import styles from './view.scss';
import Page from '../../components/page';
import Landing from './landing';
import Error from './error';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Pages = {
  main: 0,
  error: 1,
};
export default function View(props) {
  const { presenter, open, minAge, redirect, redirectDelay, format, index = Pages.main } = props;
  return (
    <Dialog
      fullScreen
      open={open}
      onClose={() => presenter?.onCloseClick()}
      TransitionComponent={Transition}
    >
      <div className={clsx(styles.content, 'age-gage-content')}>
        <Page number={Pages.main} current={index}>
          <Landing
            format={format}
            minAge={minAge}
            onComplete={(value) => {
              presenter.onAgeValidate(value);
            }}
            onRedirect={() => {
              presenter.onRedirect();
            }}
          />
        </Page>
        <Page number={Pages.error} current={index}>
          <Error minAge={minAge} redirect={redirect} redirectDelay={redirectDelay} />
        </Page>
      </div>
    </Dialog>
  );
}

View.Page = Pages;
